import Axios from 'axios';
import jwt_decode from 'jwt-decode';

interface State {
	flag: any;
}
interface IModule {
	state: State;
	mutations: any;
	actions: any;
	getters: any;
	namespaced?: boolean;
}
interface IUser {
	userName: string;
	displayName: string;
	roles: string[];
	claims: Array<{ type: string, value: string }>;
}

const user: IModule = {
	namespaced: true,
	state: {
		flag: {},
	},
	mutations: {
	},
	actions: {
		async logout({ dispatch, commit, getters, rootGetters }) {
			await dispatch('oidc/signOutOidc', {}, { root: true });
			await dispatch('oidc/removeOidcUser', {}, { root: true });
		},
	},
	getters: {
		getUser: (state: State, getters, rootState, rootGetters): IUser => {
			try {
				const accessTokenObj = jwt_decode(rootGetters['oidc/oidcAccessToken']);
				const claims: Array<{ type: string, value: string }> = [];
				if (accessTokenObj.region) {
					claims.push({ type: 'region', value: accessTokenObj.region });
				}
				return {
					userName: rootGetters['oidc/oidcUser'].name,
					displayName: rootGetters['oidc/oidcUser'].display_name,
					claims,
					roles: rootGetters['oidc/oidcUser'].role,
				};
			} catch (e) {
				// tslint:disable-next-line:no-console
				console.log(e);
				return {
					userName: '',
					displayName: '',
					claims: [],
					roles: [],
				};
			}
		},
		getRoles: (state, getters) => getters.getUser.roles,
		isInRole: (state, getters) => (...roles: string[]) => roles.some((r) => getters.getRoles.includes(r)),
		getIsAdmin: (state, getters) => getters.isInRole('superadmin', 'admin'),
		getIsUser: (state, getters) => getters.isInRole('user'),
		getIsReadOnlyUser: (state, getters) => getters.isInRole('read-only'),
		getIsContactedOnlyUser: (state, getters) => getters.isInRole('contacted-only'),
		getIsManager: (state, getters) => getters.isInRole('manager'),
		getIsOperator: (state, getters) => getters.isInRole('operator'),
		getIsTester: (state, getters) => getters.getIsAdmin || getters.isInRole('test-feature'),
	},
};
export { user as default, IUser };
